import { render, staticRenderFns } from "./customerReports.vue?vue&type=template&id=7b181638&"
import script from "./customerReports.vue?vue&type=script&lang=js&"
export * from "./customerReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports